import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import HumanResourceTab_1 from "examples/Tabs/HumanResourceTabs_1";

function Operate_2() {
  return (
    <DashboardLayout>
      <HumanResourceTab_1 />
    </DashboardLayout>
  );
}

export default Operate_2;